import { render, staticRenderFns } from "./Integral.vue?vue&type=template&id=19aface2&"
import script from "./Integral.vue?vue&type=script&lang=js&"
export * from "./Integral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports